import React from 'react';
import { Modal } from 'rsuite';
import { Button } from '@urbantxt/button';
import styles from './NotesViewModal.module.scss';

interface NotesViewModalProps {
  open: boolean;
  onClose: () => void;
  notes: string;
}

function NotesViewModal(props: NotesViewModalProps) {
  const { open, onClose, notes } = props;

  return (
    <Modal open={open} onClose={onClose} size="md">
      <Modal.Header>
        <Modal.Title>Notes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.notesContent}>
          {notes || 'No notes available.'}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" onClick={onClose} appearance="primary">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default NotesViewModal;
